/** Configuration de l'application web, lue au moment de la construction (variables VITE_*). */
export const config = {
  apiUrl: (import.meta.env.VITE_API_URL as string | undefined) ?? 'http://localhost:3000',
  /** `dev` : connexion par comptes de démonstration ; `oidc` : fournisseur d'identité (Keycloak). */
  authMode: ((import.meta.env.VITE_AUTH_MODE as string | undefined) ?? 'dev') as 'dev' | 'oidc',
  oidc: {
    authority: (import.meta.env.VITE_OIDC_AUTHORITY as string | undefined) ?? '',
    clientId: (import.meta.env.VITE_OIDC_CLIENT_ID as string | undefined) ?? 'casijud-web',
  },
};
